/**
 * Recharts theming shared by this screen's charts.
 *
 * A separate module from ChartCard.jsx on purpose: a file that exports both
 * components and constants breaks Vite's fast refresh for that file, so the
 * values live here and the components live there.
 */

export const TOOLTIP_STYLE = {
  background: 'var(--bg-surface)',
  border: '1px solid var(--border)',
  borderRadius: 8,
  fontSize: 11,
  color: 'var(--text-primary)',
  boxShadow: '0 4px 16px rgba(0,0,0,0.25)',
}

export const TOOLTIP_LABEL_STYLE = { color: 'var(--text-secondary)', fontSize: 10 }
